import React, { useState,useEffect } from 'react';
import { Col, Dropdown, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap'; 
import { ToastContainer, toast } from 'react-toastify';
import { addCheckin,getCheckInData, addCheckout } from '../../utils/usermanagement';

const CheckInOutDropdown = () => {
    //Dropdown Toggle
    const [isCheckInOutDropdown, setIsCheckInOutDropdown] = useState(false);
    const toggleCheckInOutDropdown = () => {
        setIsCheckInOutDropdown(!isCheckInOutDropdown);
    }; 
    // 新增状态    // 保持原有状态
    const [isCounting, setIsCounting] = useState(false); 
    const [startTime, setStartTime] = useState(null);
    const [checkOutTime,setCheckOutTime] = useState(null);
    const [elapsedTime, setElapsedTime] = useState(0);
    // 新增考勤记录状态
    const [checkInData, setCheckInData] = useState([]);
    const errornotify = (error) => toast(error, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-danger text-white' });
 
    // 在已有useEffect后新增数据获取逻辑
    useEffect(() => {
        const fetchCheckInData = async () => {
            try {
                const response = await getCheckInData();
                
                if (response.status === 200) {
                    if(response.data.length==0){
                        setCheckInData([]);
                        setIsCounting(false);
                        setStartTime(null);
                        setCheckOutTime(null);
                        setElapsedTime(0);
                    }else{  
                        const lastIndex = response.data.length - 1;  // 获取最后一条记录的索引
                        if(response.data[lastIndex].check_in_time && response.data[lastIndex].check_out_time == null){ 
                            const checkInTimestamp = new Date(response.data[lastIndex].check_in_time).getTime();
                            setStartTime(response.data[lastIndex].check_in_time);
                            setElapsedTime(Date.now() - checkInTimestamp);
                            setIsCounting(true);
                        } else {
                            setCheckOutTime(response.data[lastIndex].check_out_time);
                            setElapsedTime(response.data[lastIndex].duration)
                            setIsCounting(false);
                        };   
                    }
                    
                }
            } catch (error) {
                console.error("获取考勤记录失败:", error);
                toast.error("获取考勤记录失败");
            }
        };
        fetchCheckInData();
    }, []);
    
    // 添加计时器
    useEffect(() => {
        const timer = setInterval(() => {
            if (isCounting && startTime) {
                const checkInTimestamp = new Date(startTime).getTime();
                setElapsedTime(Date.now() - checkInTimestamp);
            }
        }, 1000);
        return () => clearInterval(timer);
    }, [isCounting, startTime]);

    // 新增处理函数
    const handleCheckInOut = async () => {
          ;
        if (!isCounting) {
            // 开始计时 
            
            try {
                const response = await addCheckin();
                debugger
                if (response.status === 200) {
                   // 转换新增记录的check_in_time
                   
                    const checkInTimestamp = new Date(response.data.check_in_time).getTime();
                    setStartTime(response.data.check_in_time);
                    setElapsedTime(Date.now() - checkInTimestamp);
                    setIsCounting(true);
                    toast.success("Check In Successful");
                }
                else {
                    toast.success(response.response.data.error); 
                }
            } catch (error) {
                console.error("提交失败:", error);
                errornotify(error);
            }
        } else {
            // 停止计时并提交  
            
            try {
                const response = await addCheckout();
                  
                debugger
                if (response.status === 200) {
                    setIsCounting(false);
                    setCheckOutTime(response.data.check_out_time);
                    toast.success("Check Out Successful");
                }
            } catch (error) {
                console.error("提交失败:", error);
                toast.success("Check Out failed");
            }
        }
    };
    return (
        <React.Fragment>
           <Dropdown isOpen={isCheckInOutDropdown} toggle={toggleCheckInOutDropdown} className="topbar-head-dropdown ms-1 header-item">
                <DropdownToggle type="button" tag="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle position-relative"> 
                    <span className={` p-1  ${isCounting ? 'bg-success' : 'bg-danger'} border border-light rounded-circle`}>
                        <span className="visually-hidden">Check status</span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">  
                    <ToastContainer/>
                    <div className="w-90   pt-3 mx-auto">
                        <div className="text-center mb-3">
                           {isCounting?<h6 className="mb-2 text-muted">Last check-in :{startTime && new Date(startTime).toLocaleString('en-CA', { hour12: false }).replace(',', '')}</h6>:
                                <h6 className="mb-2 text-muted">Last check-out :{checkOutTime && new Date(checkOutTime).toLocaleString('en-CA', { hour12: false }).replace(',', '')}</h6>}
                            <h3>{new Date(elapsedTime).toISOString().substr(11, 8)}</h3>
                            <button 
                                className={`btn ${isCounting ? 'btn-danger' : 'btn-success'}`}
                                onClick={handleCheckInOut}
                            >
                                {isCounting ? 'Check Out' : 'Check In'}
                            </button>
                        </div>
                    </div> 
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default CheckInOutDropdown;